import Modal, { ModalContent } from '../Modal';
import { Button } from '../Button/NewButton';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { smScreen } from '../../lib/constants';
import { Info } from '@material-ui/icons';
import clsx from 'clsx';
import { SyntheticEvent } from 'react';

interface Props {
  destructive?: boolean;
  cancelText?: string;
  confirmText?: string;
  description?: string;
  header?: string;
  open: boolean;
  onClose(): void;
  onConfirm?(): void;
  portalOut?: Element | DocumentFragment;
  subDescription?: string;
}

export const ConfirmModal = ({
  destructive = false,
  cancelText = 'No',
  confirmText = 'Yes',
  description = 'Are you sure you want to do this?',
  header = 'Confirm Action',
  onConfirm = () => null,
  onClose,
  open,
  portalOut,
  subDescription,
}: Props) => {
  const classes = useStyles();
  const isMobile = useMediaQuery(smScreen);

  const handleClose = (event: SyntheticEvent) => {
    event.stopPropagation();

    onClose();
  };

  const handleConfirm = (event: SyntheticEvent) => {
    event.stopPropagation();

    onConfirm();
    onClose();
  };

  return (
    <Modal
      className={classes.modal}
      disableBackdropClick
      hideCloseButton
      open={open}
      onClose={onClose}
      maxWidth="sm"
      portalOut={portalOut}
    >
      <ModalContent className={classes.container}>
        <div className={classes.content}>
          <span className="inline-flex items-center gap-2">
            <Info />
            <p className={classes.header}>{header}</p>
          </span>
          <p className={classes.description}>{description}</p>
          {subDescription !== undefined ? (
            <p className={classes.subDescription}>{subDescription}</p>
          ) : null}
        </div>
        <div className={classes.buttons}>
          <Button
            className={classes.button}
            fullWidth={isMobile}
            onClick={handleClose}
          >
            {cancelText}
          </Button>
          <Button
            className={clsx(classes.button, {
              'text-white !bg-red-500 hover:!bg-red-600': destructive,
            })}
            fullWidth={isMobile}
            onClick={handleConfirm}
            theme="action"
          >
            {confirmText}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

const useStyles = () => ({
  button: 'min-w-[100px] capitalize',
  buttons:
    'inline-flex items-center flex-wrap-reverse justify-end gap-2 w-full mt-4',
  content: 'block',
  container: 'h-full flex flex-col flex-start justify-between',
  description: 'opacity-100 mt-2',
  header: 'text-xl',
  modal: '!w-full !max-w-screen-sm',
  subDescription: 'opacity-70 mt-2 text-xs',
});
